import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translation } from '../../../../../../utils/helpers'

import LabelWrapper from '../../../../../../shared/elements/labelWrapper'
import Radio from '../../../../../../shared/elements/radio'
import Check from '../../../../../../shared/elements/check'

// Styles
import '../inputcomponents.scss'

class RadioList extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.translate = this.translate.bind(this)
    this.mapItems = this.mapItems.bind(this)
  }
  onInputChange (e) {
    this.props.onChange(e)
  }
  componentDidMount () {
  }
  translate (text) {
    if (!this.props.translate || isNaN(Number(text))) return text
    return translation(text)
  }
  mapItems (val, index) {
    let id = val[this.props.listItemValName[0]]
    let name = this.props.name
    let idName = name + '_' + id + '_input'

    let label
    if (typeof this.props.formatter !== 'undefined') {
      label = this.props.formatter(val, this.props.listItemValName)
    } else {
      label = this.translate(val[this.props.listItemValName[1]])
    }

    if (name === 'BodyShopTransport') {
      return (
        <Check
          id={idName}
          name={idName}
          value={id}
          onChange={this.onInputChange}
          checked={this.props.value === id.toString() ? 'checked' : false}
          disabled={this.props.disabled}
          labelText={label}
          key={index}
        />
      )
    } else {
      return (
        <Radio
          id={idName}
          name={name}
          value={id}
          onChange={this.onInputChange}
          checked={this.props.value === id.toString() ? 'checked' : false}
          disabled={this.props.disabled}
          labelText={label}
          key={index}
        />
      )
    }

    // return (
    //   <div className={className} key={index}>
    //     <input type={inputType} id={idName} name={name !== 'BodyShopTransport' ? name : idName} value={id} onChange={this.onInputChange} checked={this.props.value === id.toString() ? 'checked' : false} disabled={this.props.disabled} />
    //     <label htmlFor={idName}>
    //       {typeof this.props.formatter === 'undefined' && this.translate(val[this.props.listItemValName[1]])}
    //       {typeof this.props.formatter !== 'undefined' && this.props.formatter(val, this.props.listItemValName)}
    //     </label>
    //   </div>
    // )
  }
  render () {
    return (
      <LabelWrapper labelText={this.props.showTitle && this.translate(this.props.title)}>
        {this.props.listItems.map(this.mapItems)}
      </LabelWrapper>
    )
    // return (
    //   <div className='radio__custom__outer inputcomponents__inner'>
    //     {this.props.showTitle && <label>{this.translate(this.props.title)}</label>}
    //     <div className='radio__custom__wrapper'>
    //       {this.props.listItems.map(this.mapItems)}
    //     </div>
    //   </div>
    // )
  }
}

RadioList.defaultProps = {
  disabled: false,
  onChange: (e) => {
    console.log('todo')
  },
  name: 'None',
  value: '',
  title: '*title*',
  listItems: [],
  showTitle: true,
  listItemValName: ['', ''],
  translate: false
}

RadioList.propTypes = {
  formatter: PropTypes.func,
  mapItems: PropTypes.func,
  translate: PropTypes.bool,
  showTitle: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  listItems: PropTypes.array.isRequired,
  auth: PropTypes.object.isRequired
}

RadioList.contextTypes = {
  // t: React.PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
})(RadioList)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/NewWorkCard/InputComponents/RadioList/index.js